module.exports = __webpack_public_path__ + "static/media/test.3521b8c9.jpg";